import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const ImprintJeremywright = () => {
  const title = "{BRAND.domainLabel} meets with Sir Jeremy Wright MP."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>{title}</h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on March, 2023</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                On 3 March 2025, co-founders of {BRAND.domainLabel}, Andrew and Harleen
                Ahluwalia-Cook, met with Sir Jeremy Wright MP, who played a
                pivotal role in shaping and progressing the Online Safety Bill
                in the UK Parliament.
              </p>

              <p>
                Sir Jeremy previously served as Secretary of State for Culture,
                Media and Sport, during which time he initiated and launched the
                Online Harms White Paper in April 2019. He now serves as Vice
                Chair for the All-Party Parliamentary Group on Digital
                Regulation and Responsibility. During the meeting, Sir Jeremy
                offered valuable insights into the evolving landscape of digital
                governance in the UK. The discussion also provided an
                opportunity for Andrew and Harleen to introduce {BRAND.domainLabel} as
                an innovative alternative to mainstream social media networks,
                with a stronger focus on online safety.
              </p>

              <p>
                Founders, Andrew and Harleen highlighted {BRAND.domainLabel}&apos;s
                proactive approach to content moderation, its transparent safety
                policies and its efforts to foster healthier communities online.
              </p>

              <p>
                This meeting marks a significant step forward in
                {BRAND.domainLabel}&apos;s engagement with political stakeholders in
                the UK and reinforces its commitment to innovation in the online
                safety space.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default ImprintJeremywright;
